import { render, staticRenderFns } from "./roleAssign.vue?vue&type=template&id=7190f6a1&"
import script from "./roleAssign.vue?vue&type=script&lang=js&"
export * from "./roleAssign.vue?vue&type=script&lang=js&"
import style0 from "./roleAssign.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7190f6a1')) {
      api.createRecord('7190f6a1', component.options)
    } else {
      api.reload('7190f6a1', component.options)
    }
    module.hot.accept("./roleAssign.vue?vue&type=template&id=7190f6a1&", function () {
      api.rerender('7190f6a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/roleAssign.vue"
export default component.exports